import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import { IMemoModel } from "../../common/models/IMemoModel";
import { RouteFromObjectType } from "../../common/utilities/RouteFromObjectType";
import { IMemoAutoText } from "../offline-data-service/Models";
import OfflineDataService from "../offline-data-service/OfflineDataService";
import restService from "../rest-service/RestService";
import { IMemoAutoTextQueryParams } from "./Models";

const MemosDataService = {
    saveMemo: async function (
        customerID: number,
        groupID: number,
        memo: IMemoModel,
        offline: boolean,
        signal?: AbortSignal

    ): Promise<IMemoModel | undefined> {

        if(!offline) {
            const path: string = `groups/${groupID}/${RouteFromObjectType(memo.object)}/${memo.object.id}/memo`;

            const response = await restService.post<IMemoModel, IMemoModel>(path, memo, signal);
            return response.data;
        } else {
            await OfflineDataService.saveMemos(customerID, [memo]);
        }

    },

    saveMemos: async function (
        customerID: number,
        memos: Array<IMemoModel>,
        offline: boolean,
        signal?: AbortSignal
    ): Promise<void> {

        if(!offline){

            const path: string = "memos";
            await restService.post<Array<IMemoModel>, Array<IMemoModel>>(path, memos, signal);

        } else {
            await OfflineDataService.saveMemos(customerID, memos);
        }
    },

    deleteMemo: async function (
        customerID: number,
        groupID: number,
        memo: IMemoModel,
        offline: boolean,
        signal?: AbortSignal
    ): Promise<void> {

        if(!offline){
        
            const path: string = `groups/${groupID}/${RouteFromObjectType(memo.object)}/${memo.object.id}/memo/${memo.memoID}`;
            await restService.delete<number>(path, signal);
        
        } else {
            await OfflineDataService.deletePendingMemo(customerID, memo);
        }

    },

    // deleteAutoText: async function (
    //     groupID: number,
    //     memoAutoTextID: number,
    //     signal?: AbortSignal
    // ): Promise<number> {
        
    //     const path: string = `groups/${groupID}/memoautotext/${memoAutoTextID}`;
        
    //     const response = await restService.delete<number>(path, signal);
    //     return response.data;
    // },

    getMemoAutoText: async function (
        customerID: number,
        groupID: number,
        objectType: eLynxObjectTypeEnum,
        offline: boolean,
        signal?: AbortSignal
    ): Promise<Array<IMemoAutoText>> {

        if(!offline) {
            const path: string = `groups/${groupID}/memoautotext`;

            const queryParams: IMemoAutoTextQueryParams = {
                eLynxObjectType: objectType
            };
    
            const response = await restService.get<Array<IMemoAutoText>, IMemoAutoTextQueryParams>(path, signal, queryParams);
            return response.data;
        } else {
           
            return await OfflineDataService.getMemoAutoText(customerID, objectType);
        }
    },

    // saveAutoText: async function (
    //     groupID: number,
    //     memoAutoText: IMemoAutoText,
    //     signal?: AbortSignal
    // ): Promise<IMemoAutoText> {

    //     const path: string = `groups/${groupID}/memoautotext`;

    //     const response = await restService.post<IMemoAutoText, IMemoAutoText>(path, memoAutoText, signal);
    //     return response.data;
    // },

    manageMemoAutoTexts: async function (
        groupID: number,
        objectType: eLynxObjectTypeEnum,
        memoAutoTexts: IMemoAutoText[],
        signal?: AbortSignal
    ): Promise<void> {
        
        const path: string = `groups/${groupID}/manageautotext/${objectType.toString()}`;

        await restService.post<Array<IMemoAutoText>, void>(path, memoAutoTexts, signal);
    }
};

export default MemosDataService;
